import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  DateInput,
  required,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import { useClub } from "../club/ClubContext";

const RULE_CHOICES = [
  { id: "trainings_completed", name: "Trainings abgeschlossen (einmalig / optional window_days)" },
  { id: "trainings_per_week", name: "Trainings pro Woche (Reset wöchentlich)" },
  { id: "trainings_per_month", name: "Trainings pro Monat (Reset monatlich)" },
  { id: "trainings_per_year", name: "Trainings pro Jahr (Reset jährlich)" },

  { id: "numeric_games_completed", name: "Numeric Games abgeschlossen (einmalig / optional window_days)" },
  { id: "numeric_games_per_week", name: "Numeric Games pro Woche" },
  { id: "numeric_games_per_month", name: "Numeric Games pro Monat" },
  { id: "numeric_games_per_year", name: "Numeric Games pro Jahr" },

  { id: "numeric_score_hits", name: "Numeric: Score >= X (einmalig / optional window_days)" },
  { id: "numeric_score_hits_per_week", name: "Numeric: Score >= X pro Woche" },
  { id: "numeric_score_hits_per_month", name: "Numeric: Score >= X pro Monat" },
  { id: "numeric_score_hits_per_year", name: "Numeric: Score >= X pro Jahr" },

  { id: "numeric_value_hits", name: "Numeric: Anzahl Treffer eines Werts (einmalig / optional window_days)" },
  { id: "numeric_value_hits_per_week", name: "Numeric: Anzahl Treffer eines Werts pro Woche" },
  { id: "numeric_value_hits_per_month", name: "Numeric: Anzahl Treffer eines Werts pro Monat" },
  { id: "numeric_value_hits_per_year", name: "Numeric: Anzahl Treffer eines Werts pro Jahr" },
];

function isPeriodicRule(rule?: string) {
  return !!rule && (rule.endsWith("_per_week") || rule.endsWith("_per_month") || rule.endsWith("_per_year"));
}
function needsMatchScore(rule?: string) {
  return !!rule && rule.startsWith("numeric_score_hits");
}
function needsValueScore(rule?: string) {
  return !!rule && rule.startsWith("numeric_value_hits");
}

export function ChallengeEdit() {
  const { clubId } = useClub();

  return (
    <Edit redirect="list">
      <SimpleForm>
        <TextInput source="club_id" disabled defaultValue={clubId ?? undefined} />

        <TextInput source="name" fullWidth validate={[required()]} />
        <TextInput source="description" fullWidth multiline minRows={2} />

        {/* Rule editierbar, damit du "endlich ordentlich" alles ändern kannst */}
        <SelectInput
          source="rule_type"
          label="Regel (rule_type)"
          choices={RULE_CHOICES}
          validate={[required()]}
          fullWidth
        />

        <NumberInput source="target" validate={[required()]} />

        <FormDataConsumer>
          {({ formData }) => (
            <NumberInput
              source="window_days"
              label="Fenster (Tage)"
              helperText={
                isPeriodicRule(formData?.rule_type)
                  ? "Bei *_per_week/_per_month/_per_year wird das Kalender-Intervall verwendet (kein window_days)."
                  : "Optional: rollierendes Fenster (z. B. 7 = letzte 7 Tage)."
              }
              disabled={isPeriodicRule(formData?.rule_type)}
            />
          )}
        </FormDataConsumer>

        <NumberInput source="reward_points" validate={[required()]} />

        <FormDataConsumer>
          {({ formData }) => (
            <>
              {needsMatchScore(formData?.rule_type) && (
                <NumberInput
                  source="params.match_score"
                  label="match_score (Score >= X)"
                  helperText="Zählt Numeric-Trainings, deren Score >= match_score ist."
                  format={(v) => (v == null ? "" : v)}
                  parse={(v) => (v === "" ? null : Number(v))}
                />
              )}

              {needsValueScore(formData?.rule_type) && (
                <NumberInput
                  source="params.score"
                  label="score (Wert, z. B. 180)"
                  helperText="Summiert Treffer dieses Werts aus meta.numeric_score_hits."
                  format={(v) => (v == null ? "" : v)}
                  parse={(v) => (v === "" ? null : Number(v))}
                />
              )}

              {/* Für zukünftige, freie Params: */}
              <TextInput
                source="params_note"
                label="Hinweis (optional)"
                helperText="Falls ihr später weitere Params ergänzt, können wir hier einen JSON-Editor nachrüsten."
                disabled
                fullWidth
              />
            </>
          )}
        </FormDataConsumer>

        <DateInput source="starts_on" />
        <DateInput source="ends_on" />
        <BooleanInput source="is_active" />
      </SimpleForm>
    </Edit>
  );
}
